export type CarriersViewLayer = 'layers' | 'documents'

const LAYER_ALIASES: Record<string, CarriersViewLayer> = {
  layers: 'layers',
  'engine-layers': 'layers',
  documents: 'documents',
  'document-types': 'documents',
  files: 'documents',
}

export const isCarriersViewLayer = (value: string | undefined): boolean => {
  if (value === undefined) return true
  return LAYER_ALIASES[value] !== undefined
}

export const parseCarriersViewLayer = (
  layerParam: string | undefined,
): CarriersViewLayer => {
  if (!layerParam) return 'layers'
  return LAYER_ALIASES[layerParam] ?? 'layers'
}

export const carriersViewLayerPath = (layer: CarriersViewLayer): string =>
  layer === 'layers' ? '/carriers' : `/carriers/${layer}`
